import { useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { map } from 'lodash'
import { brReportToReportMapper } from 'pages/your-personal-data/components/reports-history/utils/mappers'

import { useQuery } from '@tanstack/react-query'

import { getReportsHistoryQueryOptions } from './queries/getReportsHistoryQueryOptions'

export const useGetReportsHistory = () => {
  const { privacyCenterContent, userCountry, isUSBranch, userSelectedEntity } = useAppContext()

  const endpoint = privacyCenterContent?.endpoints?.reports?.getReportsHistory

  const {
    data,
    isLoading: isReportsLoading,
    isError: isReportsError,
    error,
  } = useQuery(
    getReportsHistoryQueryOptions({
      endpoint,
      userCountry,
      userSelectedEntity,
      isUSBranch,
    }),
  )

  const reports = useMemo(() => {
    if (!data) return undefined

    if (userCountry === 'BR' && 'historicoRelatorioSolicitacoes' in data) {
      return map(data.historicoRelatorioSolicitacoes, (report) => brReportToReportMapper(report))
    }

    if ('dataRequestsCompleted' in data) {
      return data.dataRequestsCompleted
    }

    return undefined
  }, [data, userCountry])

  return {
    reports,
    isReportsLoading,
    isReportsError,
    error,
  }
}
